/**
 * Zone.js configuration flags
 *
 * IMPORTANTE: Este archivo debe importarse ANTES de zone.js
 *
 * Deshabilitamos el patching de eventos de mouse para evitar que Zone.js
 * intercepte los 127 eventos/seg de mousemove que genera Mapbox durante
 * navegación del mapa, causando 63,000+ RunTask events.
 *
 * Con estos flags:
 * - mouseenter/mouseleave siguen funcionando para cambiar cursor
 * - click sigue funcionando para abrir popups (usamos ngZone.run() explícitamente)
 * - Reducción esperada: ~53% menos eventos procesados por Zone.js
 *
 * Documentación: https://github.com/angular/angular/blob/main/packages/zone.js/MODULE.md
 */

// Deshabilitar patching de eventos de mouse
(window as any).__Zone_disable_mousemove = true;
(window as any).__Zone_disable_mouseenter = true;
(window as any).__Zone_disable_mouseleave = true;
(window as any).__Zone_disable_mouseover = true;
(window as any).__Zone_disable_mouseout = true;

// También deshabilitar wheel para zoom del mapa
(window as any).__Zone_disable_wheel = true;

// NOTA: NO deshabilitamos 'click' porque algunos componentes podrían depender
// de change detection en clicks. Nuestros mapas ya usan ngZone.run() explícitamente
// en los click handlers, así que funcionarán bien.
